import React, { useContext, useEffect } from 'react'
import { ChargeCodeContext } from '../../../Contexts/ChargeCode/ChargeCodeContext'
import { ChargeCodeModalContent } from './ChargeCodeModalContent'

const overlayWrapperStyle = {
  width: '100vw',
  height: '100vh',
  position: 'fixed',
  zIndex: 11,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const backdropButtonStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  margin: 0,
  padding: 0,
  border: 'none',
  background: 'rgba(0,0,0,0.4)',
  cursor: 'default',
}

const modalStyle = {
  position: 'relative',
  zIndex: 1,
  minWidth: '320px',
  maxWidth: '90vw',
  maxHeight: '90vh',
  boxSizing: 'border-box',
  backgroundColor: '#fff',
  padding: '40px',
  borderRadius: '4px',
  overflowY: 'auto',
  fontFamily: "'McKinsey Sans', sans-serif"
}

export function ChargeCodeModal() {
  const { chargeCode, chargeCodeModal, closeChargeCodeModal } = useContext(ChargeCodeContext)
  const { isOpen, actionLabel } = chargeCodeModal

  useEffect(() => {
    if (!isOpen) return undefined
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeChargeCodeModal()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [isOpen, closeChargeCodeModal])

  if (!isOpen) return null

  const modalTitle = actionLabel === 'Generate'
    ? 'Please enter charge code for report generation'
    : chargeCode.isActive !== null
      ? 'Update Charge Code'
      : 'Enter Charge Code'

  return (
    <div
      style={overlayWrapperStyle}
      role="dialog"
      aria-modal="true"
      aria-labelledby="charge-code-title"
    >
      <button
        type="button"
        tabIndex={-1}
        aria-label="Close dialog"
        style={backdropButtonStyle}
        onClick={closeChargeCodeModal}
      />
      <div style={modalStyle}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '16px', marginBottom: '20px', paddingBottom: '2px' }}>
          <h1
            id="charge-code-title"
            style={{
              fontSize: '24px',
              fontWeight: 500,
              margin: 0,
              flex: 1,
              fontFamily: "'McKinsey Sans', sans-serif",
              color: actionLabel === 'Generate' ? '#2251ff' : undefined
            }}
          >
            {modalTitle}
          </h1>
          <button
            type="button"
            onClick={closeChargeCodeModal}
            aria-label="Close"
            style={{
              flexShrink: 0,
              background: 'none',
              border: 'none',
              padding: '4px',
              cursor: 'pointer',
              fontSize: '20px',
              lineHeight: 1,
              color: '#333',
              fontFamily: "'McKinsey Sans', sans-serif"
            }}
          >
            ×
          </button>
        </div>
        <ChargeCodeModalContent />
      </div>
    </div>
  )
}